import { render, staticRenderFns } from "./aside-bar.vue?vue&type=template&id=72127d5b&scoped=true"
import script from "./aside-bar.vue?vue&type=script&lang=ts"
export * from "./aside-bar.vue?vue&type=script&lang=ts"
import style0 from "./aside-bar.vue?vue&type=style&index=0&id=72127d5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72127d5b",
  null
  
)

export default component.exports